/* NutriFitt Resurrection: chapter rail + scroll reveals for the product pages. */
(() => {
  const run = () => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  /* Chapter rail on the landing page: follows the chapter in view. */
  const rail = document.querySelector('[data-ng-rail]');
  if (rail && 'IntersectionObserver' in window) {
    const links = [...rail.querySelectorAll('a[href^="#"]')];
    const targets = links.map(link => document.getElementById(link.getAttribute('href').slice(1))).filter(Boolean);
    const hero = document.querySelector('.lp-hero');
    const mark = id => links.forEach(link => link.setAttribute('aria-current', String(link.getAttribute('href') === '#' + id)));
    const chapters = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) mark(entry.target.id); });
    }, { rootMargin: '-45% 0px -50% 0px' });
    targets.forEach(target => chapters.observe(target));
    if (hero) new IntersectionObserver(([entry]) => rail.classList.toggle('is-on', !entry.isIntersecting), { threshold: 0.15 }).observe(hero);
    else rail.classList.add('is-on');
  }

  /* Product pages: reveal the long-form blocks as they arrive. */
  const root = document.querySelector('#content.nf-rp');
  if (!root || reduced.matches || !('IntersectionObserver' in window)) return;
  const picks = ['.nf-edition', '.nf-crucifix-facts', '.nf-crucifix-dossier', '.jdgm-rev-widg__header', '.product-recommendations .section-title', '.product-recommendations .product-block'];
  const items = [];
  picks.forEach(selector => document.querySelectorAll(selector).forEach(element => {
    if (element.getBoundingClientRect().top < innerHeight * 0.9) return;
    element.setAttribute('data-ng-reveal', '');
    items.push(element);
  }));
  if (!items.length) return;
  root.classList.add('ng-motion');
  const seen = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('is-in');
    seen.unobserve(entry.target);
  }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  items.forEach((element, index) => {
    element.style.setProperty('--ng-i', String(index % 4));
    seen.observe(element);
  });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
